import { render, staticRenderFns } from "./Parameter.vue?vue&type=template&id=c0672c0c&"
import script from "./Parameter.vue?vue&type=script&lang=ts&"
export * from "./Parameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports